export default {
  webBoardReplies: [],
  processing: false,
  error: null,
  success: null,
}



